// import { useState } from 'react'
// // import { Button } from '../../../components/common'
// import Icons from '../../../components/common/icons'
// import Navigator from '../../../components/common/Navigator'
// import { useCareersList } from '../api'

// const Careers = () => {
//   const [expandedCardId, setExpandedCardId] = useState<number | null>(null)

//   const { data } = useCareersList()

//   // const stripHtmlTags = (htmlString: string) => {
//   //   const doc = new DOMParser().parseFromString(htmlString, 'text/html')
//   //   return doc.body.textContent || ''
//   // }
//   const stripHtmlTags = (htmlString: string) => {
//     const doc = new DOMParser().parseFromString(htmlString, 'text/html')
//     return doc.body.textContent?.trim() || ''
//   }

//   const capitalizeFirst = (text: string) =>
//     text ? text.charAt(0).toUpperCase() + text.slice(1) : ''

//   const toggleReadMore = (id: number) => {
//     setExpandedCardId((prev) => (prev === id ? null : id))
//   }

//   return (
//     <div className="lg:w-11/12 mx-auto p-4 lg:p-0 lg:my-8">
//       <Navigator title="Careers" slug="Careers" />
//       <h1 className="text-3xl font-semibold text-gray-800 pb-1">Careers</h1>
//       <p className="text-PrimaryGray text-sm pb-3">
//         Discover your career in a world of innovative interior design. At Urban
//         Luxe, we are looking for passionate, creative minds to help us redefine
//         spaces with elegance and style.
//       </p>
//       <hr className="border-t-2 border-primaryBlue mb-6" />

//       <div className="flex flex-wrap gap-12">
//         {data?.data?.map((career: any) => {
//           // const cleanDesc = stripHtmlTags(career?.description)
//           // const isExpanded = expandedCardId === career.id
//           // const capitalizeFirst = (text:any) =>
//           //   text ? text.charAt(0).toUpperCase() + text.slice(1) : ''
//           const cleanDesc = stripHtmlTags(career?.description || '')
//           const isExpanded = expandedCardId === career.id

//           return (
//             <div
//               key={career?.id}
//               className="w-full md:w-[48%] border border-inputBg rounded-md p-5 shadow-[0_4px_6px_0_#FFDFB740] transition-all duration-300 ease-in-out"
//             >
//               <div className="flex items-center gap-2 mb-3">
//                 <span className="text-xs text-LightGreen bg-BgGreen px-2 py-0.5 rounded-full">
//                   New
//                 </span>
//               </div>

//               <h2 className="font-barlow font-medium text-[18px] leading-[19px] tracking-normal mb-3">
//                 {/* {career?.title} */}
//                 {capitalizeFirst(career?.title)}
//               </h2>

//               <p
//                 className={`font-barlow font-light text-[12px] tracking-normal text-gray-900 text-justify mb-2 ${
//                   !isExpanded ? 'line-clamp-4' : ''
//                 }`}
//               >
//                 {/* {cleanDesc} */}
//                 {capitalizeFirst(cleanDesc)}
//               </p>

//               {cleanDesc.length > 200 && (
//                 <button
//                   onClick={() => toggleReadMore(career.id)}
//                   className="text-LightGreen text-xs font-semibold underline mb-3"
//                 >
//                   {isExpanded ? 'Read Less' : 'Read More'}
//                 </button>
//               )}
//               {career?.location && career?.type && (
//                 <div className="flex flex-wrap items-center text-xs text-gray-900 gap-4 mb-3">
//                   <div className="flex items-center gap-3 text-PrimaryGray text-[14px] font-[500]">
//                     <Icons name="location" className="w-4 h-4" />
//                     {career?.location}
//                   </div>
//                   <div className="flex items-center gap-3 text-PrimaryGray text-[14px] font-[500]">
//                     <Icons name="calendar" className="w-4 h-6" />
//                     {career?.type}
//                   </div>
//                 </div>
//               )}

//               {/* <div className="flex justify-start">
//                 <Button
//                   outlined
//                   label="Apply Now"
//                   className="w-40 hover:text-white text-LightGreen hover:bg-LightGreen border-LightGreen hover:border-LightGreen text-sm"
//                 />
//               </div> */}
//             </div>
//           )
//         })}
//       </div>
//     </div>
//   )
// }

// export default Careers

// import { useState } from 'react'
// import Icons from '../../../components/common/icons'
// import Navigator from '../../../components/common/Navigator'
// import { useCareersList } from '../api'

// const Careers = () => {
//   const [expandedCardId, setExpandedCardId] = useState<number | null>(null)
//   const { data } = useCareersList()

//   const capitalizeFirst = (text: string) =>
//     text ? text.charAt(0).toUpperCase() + text.slice(1) : ''

//   const toggleReadMore = (id: number) => {
//     setExpandedCardId((prev) => (prev === id ? null : id))
//   }

//   return (
//     <div className="lg:w-11/12 mx-auto p-4 lg:p-0 lg:my-8">
//       <Navigator title="Careers" slug="Careers" />
//       <h1 className="text-3xl font-semibold text-gray-800 pb-1">Careers</h1>
//       <p className="text-PrimaryGray text-sm pb-3">
//         Discover your career in a world of innovative interior design. At Urban
//         Luxe, we are looking for passionate, creative minds to help us redefine
//         spaces with elegance and style.
//       </p>
//       <hr className="border-t-2 border-primaryBlue mb-6" />

//       <div className="flex flex-wrap gap-12">
//         {data?.data?.map((career: any) => {
//           const isExpanded = expandedCardId === career.id

//           return (
//             <div
//               key={career?.id}
//               className="w-full md:w-[48%] border border-inputBg rounded-md p-5 shadow-[0_4px_6px_0_#FFDFB740] transition-all duration-300 ease-in-out"
//             >
//               <div className="flex items-center gap-2 mb-3">
//                 <span className="text-xs text-LightGreen bg-BgGreen px-2 py-0.5 rounded-full">
//                   New
//                 </span>
//               </div>

//               <h2 className="font-barlow font-medium text-[18px] leading-[22px] tracking-normal mb-3">
//                 {capitalizeFirst(career?.title)}
//               </h2>

//               {/* ✅ Render formatted HTML with bullets, bold, etc. */}
//               {/* <div
//                 className={`career-description prose prose-sm max-w-none font-barlow text-[13px] text-gray-900 text-justify mb-3 prose-li:marker:text-black prose-ul:pl-6 prose-ol:pl-6 ${
//                   !isExpanded ? 'line-clamp-6' : ''
//                 }`}
//                 dangerouslySetInnerHTML={{
//                   __html: career?.description || '',
//                 }}
//               /> */}
//               <div
//                 style={{
//                   fontFamily: 'Barlow, sans-serif',
//                   fontSize: '13px',
//                   color: '#111827', // text-gray-900
//                   textAlign: 'justify',
//                 }}
//                 dangerouslySetInnerHTML={{
//                   __html:
//                     career?.description
//                       ?.replace(
//                         /<ul>/g,
//                         `<ul style="list-style-type: disc; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
//                       )
//                       .replace(
//                         /<ol>/g,
//                         `<ol style="list-style-type: decimal; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
//                       )
//                       .replace(
//                         /<li>/g,
//                         `<li style="margin-bottom: 0.25rem;">`
//                       ) || '',
//                 }}
//                 className={`career-description prose prose-sm max-w-none font-barlow text-[13px] text-gray-900 text-justify mb-3 prose-li:marker:text-black prose-ul:pl-6 prose-ol:pl-6 `}
//               />

//               {/* {career?.description?.length > 300 && (
//                 <button
//                   onClick={() => toggleReadMore(career.id)}
//                   className="text-LightGreen text-xs font-semibold underline mb-3"
//                 >
//                   {isExpanded ? 'Read Less' : 'Read More'}
//                 </button>
//               )}
//  */}
//                 {career?.description?.length > 200 && (
//                  <button
//                    onClick={() => toggleReadMore(career.id)}
//                    className="text-LightGreen text-xs font-semibold underline mb-3"
//                  >
//                    {isExpanded ? 'Read Less' : 'Read More'}
//                  </button>
//                )}

//               {career?.location && career?.type && (
//                 <div className="flex flex-wrap items-center text-xs text-gray-900 gap-4 mb-3">
//                   <div className="flex items-center gap-3 text-PrimaryGray text-[14px] font-[500]">
//                     <Icons name="location" className="w-4 h-4" />
//                     {career?.location}
//                   </div>
//                   <div className="flex items-center gap-3 text-PrimaryGray text-[14px] font-[500]">
//                     <Icons name="calendar" className="w-4 h-6" />
//                     {career?.type}
//                   </div>
//                 </div>
//               )}
//             </div>
//           )
//         })}
//       </div>
//     </div>
//   )
// }

// export default Careers

import { useState } from 'react'
import Icons from '../../../components/common/icons'
import Navigator from '../../../components/common/Navigator'
import { useCareersList } from '../api'

const Careers = () => {
  const [expandedCardId, setExpandedCardId] = useState<number | null>(null)
  const { data } = useCareersList()

  const capitalizeFirst = (html: string) => {
    if (!html) return ''

    // Replace the first visible letter ignoring HTML tags
    return html.replace(/^(\s*<[^>]+>)*([a-zA-Z])/, (match, tags, letter) => {
      return (tags || '') + letter.toUpperCase()
    })
  }

  // const capitalizeFirstVisibleLetter = (html: string) => {
  //   if (!html) return '';

  //   // Replace first visible letter, ignoring HTML tags
  //   return html.replace(/^(\s*<[^>]+>)*([a-zA-Z])/, (match, tags, letter) => {
  //     return (tags || '') + letter.toUpperCase();
  //   });
  // };

  const toggleReadMore = (id: number) => {
    setExpandedCardId((prev) => (prev === id ? null : id))
  }

  // Strip HTML tags to get text-only for truncation
  const stripHtmlTags = (htmlString: string) => {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html')
    return doc.body.textContent?.trim() || ''
  }

  return (
    <div className="lg:w-11/12 mx-auto p-4 lg:p-0 lg:my-8">
      <Navigator title="Careers" slug="Careers" />
      <h1 className="text-3xl font-semibold text-gray-800 pb-1">Careers</h1>
      <p className="text-PrimaryGray text-sm pb-3">
        Discover your career in a world of innovative interior design. At Urban
        Luxe, we are looking for passionate, creative minds to help us redefine
        spaces with elegance and style.
      </p>
      <hr className="border-t-2 border-primaryBlue mb-6" />

      <div className="flex flex-wrap gap-12">
        {data?.data?.map((career: any) => {
          const isExpanded = expandedCardId === career.id
          const textOnly = stripHtmlTags(career?.description || '')
          const showReadMore = textOnly.length > 200

          return (
            <div
              key={career?.id}
              className="w-full md:w-[48%] border border-inputBg rounded-md p-5 shadow-[0_4px_6px_0_#FFDFB740] transition-all duration-300 ease-in-out"
            >
              <div className="flex items-center gap-2 mb-3">
                <span className="text-xs text-LightGreen bg-BgGreen px-2 py-0.5 rounded-full">
                  New
                </span>
              </div>

              <h2 className="font-barlow font-medium text-[18px] leading-[22px] tracking-normal mb-3">
                {capitalizeFirst(career?.title)}
              </h2>

              {/* <div
  dangerouslySetInnerHTML={{
    __html: isExpanded
      ? capitalizeFirst(career?.description || '')
          .replace(
            /<ul>/g,
            `<ul style="list-style-type: disc; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
          )
          .replace(
            /<ol>/g,
            `<ol style="list-style-type: decimal; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
          )
          .replace(
            /<li>/g,
            `<li style="margin-bottom: 0.25rem;">`
          )
      : `${textOnly.slice(0, 200)}...`,
  }}
/> */}
              <div
                dangerouslySetInnerHTML={{
                  __html: (() => {
                    // Choose the text based on isExpanded
                    const text = isExpanded
                      ? career?.description || ''
                      : textOnly.slice(0, 200)

                    if (!text) return ''

                    // Capitalize the first visible letter safely
                    const capitalized = text.replace(
                      /^(\s*<[^>]+>)*([a-zA-Z])?/,
                      (match: any, tags: any, letter: any) => {
                        if (!letter) return match // if no letter, return as-is
                        return (tags || '') + letter.toUpperCase()
                      }
                    )

                    // Add inline styles for lists
                    return capitalized
                      .replace(
                        /<ul>/g,
                        `<ul style="list-style-type: disc; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
                      )
                      .replace(
                        /<ol>/g,
                        `<ol style="list-style-type: decimal; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
                      )
                      .replace(/<li>/g, `<li style="margin-bottom: 0.25rem;">`)
                  })(),
                }}
              />

              {showReadMore && (
                <button
                  onClick={() => toggleReadMore(career.id)}
                  className="text-LightGreen text-xs font-semibold underline mb-3"
                >
                  {isExpanded ? 'Read Less' : 'Read More'}
                </button>
              )}

              {career?.location && career?.type && (
                <div className="flex flex-wrap items-center text-xs text-gray-900 gap-4 mb-3">
                  <div className="flex items-center gap-3 text-PrimaryGray text-[14px] font-[500]">
                    <Icons name="location" className="w-4 h-4" />
                    {career?.location}
                  </div>
                  <div className="flex items-center gap-3 text-PrimaryGray text-[14px] font-[500]">
                    <Icons name="calendar" className="w-4 h-6" />
                    {career?.type}
                  </div>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Careers
